<template>
<div class="">
     <div class="sec-9-hex">
         <img src="theme/img/footer-hex.svg">
         <div class="model1">
              <span class="blue-light"></span>
               <span class="blue-light"></span>
                <span class="blue-light"></span>
                 <span class="blue-light"></span>
         </div>
      </div>
      <footer>
      <div class="container">
          <div class="row footer-sections">
              <div class="col-lg-3 ">
                  <div class="f-sec">
                      <h3>Home</h3>
                      <ul>
                        <li><a href="#/">Faq</a></li>
                         <li><a href="https://blog.alphaq.ai/" target="_blank">Blog</a></li>
                         <li><a href="/contact">Contact</a></li>
                      </ul>
                  </div>
              </div>
              <div class="col-lg-3">
                  <div class="f-sec">
                      <h3>Join Us</h3>
                      <ul>
                        <li><a href="https://partner.alphaq.ai/" target="_blank">Partners</a></li>
                        <li><a href="https://blog.alphaq.ai/apply-now/" target="_blank">Career</a></li>
                      </ul>
                  </div>
              </div>
              <div class="col-lg-3">
                  <div class="f-sec">
                      <h3>Mail</h3>
                      <div class="sub">                     
                        <p>
                           <a href="">info@alphaq.ai</a>
                        </p>
                    </div>
                   
                  </div>
              </div>
              <div class="col-lg-3">
                <div class="f-sec">
                     <div class="sub">
                        <h3>FOLLOW US</h3>
                        <ul class="social-links">
                            <li><a href="https://www.facebook.com/alphaq.community" target="_blank"> <img src="/theme/img/icons/facebook-f.svg"></a></li>
                            <li><a href="https://www.instagram.com/alphaq.ai/" target="_blank"><img src="/theme/img/icons/instagram.svg"> </a></li>
                            <li><a href="https://twitter.com/alphaq_ai" target="_blank"><img src="/theme/img/icons/twitter.svg">  </a></li>
                            <li><a href="https://www.youtube.com/channel/UCCzoztOhf1y7tHsr92nsUaA" target="_blank"><img src="/theme/img/icons/youtube.svg"> </a></li>
                            <li><a href="https://www.linkedin.com/company/alphaq-community" target="_blank"><img src="/theme/img/icons/linkedin-in.svg"> </a></li>
                            <li><a href="https://discord.gg/7rawnUV4" target="_blank"><img src="/theme/img/icons/discord.svg"> </a></li>
                        </ul>
                    </div>
                </div>
              </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
                 <div class="f-sec text-center">
                      <h3>Locations</h3>
                 </div>
            </div>
          </div>
          <div class="row mt-3 mb-3">
              <div class="col-lg-4">
                  <div class="f-sec ftr-locations">
                      <div class="sub text-center">
                            <h6>USA</h6>
                            <p>
                            256 Chapman Road,<br>
                            STE 105-4 Newark, New Castle,<br>
                            United States of America - 19702
                            </p>
                        </div>
                  </div>
              </div>
               <div class="col-lg-4">
                  <div class="f-sec ftr-locations">
                      <div class="sub text-center">
                            <h6>Bangalore, India</h6>
                            <p>
                            Work365, #737, Kheny Plaza 3rd and 4th floor,<br>
                            1st Stage, 2nd Cross, CMH Road, Indranagar,<br>
                            Bangalore - 560038
                            </p>
                        </div>
                  </div>
              </div>
               <div class="col-lg-4">
                  <div class="f-sec ftr-locations">
                      <div class="sub text-center">
                            <h6>Kochi, India</h6>
                            <p>
                            Thapasya Annexe,<br>
                            Near Thapasya Building,<br>
                            Infopark Campus, Kochi P.O. - 682042
                            </p>
                        </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="footer-bar" >
          <p>Copyright @ algorithma .Inc</p>
      </div>
  </footer>
</div>
 
</template>
<style scoped>
    .sec-9-hex{
        width: 100%;
        display: inline-block;
        background-size: 100%;
        position: relative;
            overflow: hidden;

    }
    .sec-9-hex::before{
        width: 100%;
        height: 100%;
        content: '';
        position: absolute;
        background: url(/theme/img/footer-hex.svg);
        background-size: 120%;
        background-position-y: top;
            background-position-x: 14%;

        background-repeat: no-repeat;
            z-index: 2;
    }
    .sec-9-hex img{
        width: 100%;
        opacity: 0;
        visibility: hidden;
    }
.sec-9-hex .model1{
 width: 100%;
 position: absolute;
 left: 0;
 height: 100%;
 top: 0%;
}
    .sec-9-hex .model1 img{
        visibility: hidden;
        opacity: 0px;
    }
    .sec-9-hex .model1 .blue-light:nth-child(1){
        top: 43%;
    left: 1%;
    }
    .sec-9-hex .model1 .blue-light:nth-child(2){
       top: 65%;
    left: 21.5%;
    }
    .sec-9-hex .model1 .blue-light:nth-child(3){
      top: 65%;
    left: 62.5%;
    }
    .sec-9-hex .model1 .blue-light:nth-child(4){
     top: 66%;
    left: 92%;
    }
</style>
<script>
export default {};
</script>
